export default {
    modal_title: "Adicionar estopa",
    unit_price: "Valor unitario",
    quantity: "Quantidade",
    subtotal_with_colon: "Subtotal:",
    cancel: "Cancelar",
    add: "Adicionar",
    client_search_placeholder: "Buscar cliente...",
    client_1: "Cliente 1",
    client_2: "Cliente 2",
    client_3: "Cliente 3",
    product_search_placeholder: "Pesquisar produto...",
    product_1: "Produto 1",
    product_2: "Produto 2",
    product_3: "Produto 3",
    product: "Produto",
    subtotal: "Subtotal",
    total: "Total",
    add_product: "Adicionar produto",
    advance_payment: "Avancar para pagamento",
    coupon: "Cupom",
    apply: "Aplicar",
    save_sale: "Salvar venda",
    sale_success: "Venda realizada com sucesso!",
    new_sale: "Nova venda",
};
